// extracted by mini-css-extract-plugin
module.exports = {"positionContainer":"CurrentPosition_positionContainer__3wO1k","yourPosition":"CurrentPosition_yourPosition__1OZWj","pulse-red":"CurrentPosition_pulse-red__1fR1l"};